import { render, staticRenderFns } from "./DocumentalAssistantForm.vue?vue&type=template&id=ed3b8962&lang=pug&"
import script from "./DocumentalAssistantForm.vue?vue&type=script&lang=js&"
export * from "./DocumentalAssistantForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports